import React from "react";
import clsx from "clsx";

import styles from "./textarea.module.scss";

const Textarea = React.forwardRef(function Textarea(
  {
    id,
    className,
    label,
    name,
    value,
    helpText,
    errorText,
    successText,
    ...props
  },
  ref
) {
  return (
    <div className={styles.FormGroup}>
      {label && <label htmlFor={name}>{label}</label>}
      <textarea
        className={clsx(
          styles.Textarea,
          errorText && "is-invalid",
          successText && "is-valid",
          className
        )}
        name={name}
        id={id || name}
        ref={ref}
        {...props}
      >
        {value}
      </textarea>

      {helpText && <small className="form-text text-muted">{helpText}</small>}

      {errorText && <div className="text-danger">{errorText}</div>}

      {successText && <div className="text-success">{successText}</div>}
    </div>
  );
});

export default Textarea;
